import React, { useState, useEffect } from 'react'
import useManageWeeklyShip from './useManageWeeklyShip';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import { toast } from 'react-toastify';

const WeeklyShipBoxWeightInsert = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [highestIndex, setHighestIndex] = useState(0);
  const [shipDate, setShipDate] = useState('');
  const [images, setImages] = useState([]);
  const [boxNo, setBoxNo] = useState('');
  const [weight, setWeight] = useState('');
  const [trackingNo, setTrackingNo] = useState('');
  const [history, setHistory] = useState([]);
  const {boxUrl, pendingUploadCount, getUnmatchBoxUrlAir, createWeeklyShipAir} = useManageWeeklyShip()

  // Function to analyze codes and pre-fill form fields
  const analyzeCodesAndPreFill = (codes) => {
    if (!codes || codes.length === 0) return;

    let foundBoxNo = null;
    let foundTrackingNo = null;

    codes.forEach(code => {
      
      // Check for box number pattern: 2025-11-24_30 (extract only the number after _)
      if (code.includes('_')) {
        const parts = code.split('_');
        if (parts.length > 1) {
          foundBoxNo = parts[1]; // Get only the number after the underscore
        }
      }
      
      // Check for tracking number pattern: 10-14 characters, often wrapped with A or D
      if (code.length >= 10 && code.length <= 14) {
        // Check if it's wrapped with A or D
        if ((code.startsWith('A') && code.endsWith('A')) || 
            (code.startsWith('D') && code.endsWith('D'))) {
          // Remove wrapper characters (first and last character)
          foundTrackingNo = code.slice(1, -1);
        } else if (/^[0-9]+$/.test(code)) {
          // Pure numeric tracking number
          foundTrackingNo = code;
        }
      }
    });

    // Pre-fill the form fields
    if (foundBoxNo) {
      setBoxNo(foundBoxNo);
      console.log('Pre-filled Box No:', foundBoxNo);
    }
    
    if (foundTrackingNo) {
      setTrackingNo(foundTrackingNo);
      console.log('Pre-filled Tracking No:', foundTrackingNo);
    }
  };

  const onEnter = async () => {
    if(boxNo !== ''){
      // Check if weight is provided
      if(weight === '' || weight === null || weight === undefined){
        toast.warning("กรุณาใส่น้ำหนัก")
        console.log("Please Enter Weight")
        return;
      }

      const existingIndex = history.findIndex(item => item.image === boxUrl[currentIndex]?.shipImageUrl);
      console.log(boxUrl[currentIndex])
      
      if (existingIndex !== -1) {
        // Update existing item in history
        setHistory(prevHistory => prevHistory.map((item, index) => 
          index === existingIndex ? { 
            ...item, 
            boxNo: boxNo,
            weight: weight,
            trackingNo: trackingNo
          } : item
        ));
      } else {
        // Add new item to history
        setHistory([
          ...history, 
          { 
            boxNo: boxNo, 
            weight: weight,
            trackingNo: trackingNo,
            image: boxUrl[currentIndex]?.shipImageUrl 
          }
        ]);
      }

      const payload = {
        shipImageId: boxUrl[currentIndex].id,
        boxNo: boxNo,
        weight: weight || null,
        trackingJp: trackingNo || null,
        shipDateId: shipDate,
      };

      const response = await createWeeklyShipAir(payload)
      if(response.success){
        toast.success("SUCCESS - Box No: " + boxNo + (weight ? " Weight: " + weight : "") + (trackingNo ? " Tracking: " + trackingNo : ""))
      } else if(response.message?.includes('already exists')) {
        toast.error(`เลขกล่อง ${boxNo} ซ้ำ — มีข้อมูลนี้อยู่แล้วในรอบบินนี้`)
        return
      } else {
        toast.error('เพิ่มข้อมูลไม่สำเร็จ ติดต่อพี่เกน')
      }

      if(currentIndex == highestIndex){
        setCurrentIndex(currentIndex + 1);
      }else{
        setCurrentIndex(highestIndex);
      }
      
      // Clear inputs after successful submission
      setBoxNo('');
      setWeight('');
      setTrackingNo('');
    }else{
      toast.warning("กรูณาใส่เลขกล่อง")
      console.log("Please Enter Box Number")
    }
  }

  const handleKeyPress = (event) => {
    if(event.key === 'Enter') {
      onEnter()
    }
  }

  const handleButtonClick = () => {
    onEnter()
  }

  const handleBoxNoChange = (e) => {
    const value = e.target.value;
    // Allow only positive numbers
    if (/^[0-9]*$/.test(value)) {
      setBoxNo(value);
    }
  }

  const handleWeightChange = (e) => {
    const value = e.target.value;
    // Allow numbers with decimal point
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      setWeight(value);
    }
  }

  const handleTrackingNoChange = (e) => {
    const value = e.target.value;
    // Allow alphanumeric characters and common tracking number formats
    setTrackingNo(value);
  }

  const handleHistoryClick = (index) => {
    if(history.length > 3){
      setCurrentIndex(history.length - 3 + index);
    }else{  
      setCurrentIndex(index);
    }
    console.log(history, index)
  };

  const handleSelectChange = async (e) => {
    await getUnmatchBoxUrlAir(e.target.value)
    setShipDate(e.target.value)
  }

  useEffect(() => {
    if (boxUrl.length > 0 && currentIndex + 1 < boxUrl.length) {
      const nextImage = new Image();
      nextImage.src = boxUrl[currentIndex + 1].shipImageUrl;
      nextImage.onload = () => {
        console.log('Next image preloaded!');
      };
    }
  }, [currentIndex, boxUrl]);

  useEffect(() => {
    if(currentIndex > highestIndex){
      setHighestIndex(currentIndex)
    }
  }, [currentIndex])

  // Effect to analyze codes when image changes
  useEffect(() => {
    if (boxUrl[currentIndex] && boxUrl[currentIndex].codes) {
      console.log('Image changed, analyzing codes:', boxUrl[currentIndex].codes);
      analyzeCodesAndPreFill(boxUrl[currentIndex].codes);
    } else {
      // Clear form when no image or no codes
      setBoxNo('');
      setTrackingNo('');
      setWeight('');
    }
  }, [currentIndex, boxUrl]);

  return (
    <div className='h-screen grid grid-cols-3 gap-x-10'>
      <div className='col-span-2'>
        <ShipDateDropdown 
          handleDataChange={handleSelectChange}
          includeDefault={true}
          airOnly={true}
        />
        
        {shipDate && (
          <div className="mb-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200 text-blue-800 text-lg">
            {pendingUploadCount > 0 ? (
              <>
                พร้อมใช้งาน <strong>{boxUrl.length} รูป</strong> | กำลังอัปโหลดอยู่ <strong>{pendingUploadCount} รูป</strong> — หลังจากดำเนินการ {boxUrl.length} รูปเสร็จแล้ว กรุณารีเฟรชเพื่อโหลดรูปใหม่
              </>
            ) : (
              <>พร้อมใช้งาน <strong>{boxUrl.length} รูป</strong></>
            )}
          </div>
        )}

        {/* Image and Input Fields Side by Side */}
        <div className="flex gap-6" style={{ height: '90vh' }}>
          {/* Image Section */}
          <div className="flex-1">
            {boxUrl[currentIndex] ?
              <img className="h-full w-full object-contain" src={boxUrl[currentIndex]?.shipImageUrl} alt="current" />
              : <p className='h-full text-5xl py-10 flex items-center justify-center'>No more Image</p>
            }
          </div>
          
          {/* Input Fields Section */}
          <div className="w-80 space-y-6">
            <div>
              <label className="block text-2xl font-bold mb-2">Box Number</label>
              <input 
                className='input-form text-3xl w-full'
                name="boxNo"
                type="text" 
                value={boxNo} 
                onChange={handleBoxNoChange}
                onKeyDown={handleKeyPress}
                placeholder="Enter box number"
                required
              />
            </div>
            
            <div>
              <label className="block text-2xl font-bold mb-2">Tracking Number</label>
              <input 
                className='input-form text-3xl w-full'
                name="trackingNo"
                type="text" 
                value={trackingNo} 
                onChange={handleTrackingNoChange}
                onKeyDown={handleKeyPress}
                placeholder="Enter tracking number"
              />
            </div>
 
                        
            <div>
              <label className="block text-2xl font-bold mb-2">Weight* (kg)</label>
              <input 
                className='input-form text-3xl w-full'
                name="weight"
                type="text" 
                value={weight} 
                onChange={handleWeightChange}
                onKeyDown={handleKeyPress}
                placeholder="Enter weight in kg"
              />
            </div>
            
            <button className='btn btn-blue text-2xl w-full' onClick={handleButtonClick}>Save</button>
            
            {/* Decoded Codes Display */}
            {boxUrl[currentIndex] && boxUrl[currentIndex].codes && boxUrl[currentIndex].codes.length > 0 && (
              <div className="mt-4 p-3 bg-gray-100 rounded-lg">
                <h3 className="text-lg font-bold mb-2">Decoded Codes:</h3>
                <div className="space-y-1 max-h-32 overflow-y-auto">
                  {boxUrl[currentIndex].codes.map((code, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <span className="text-xs text-gray-600">#{index + 1}:</span>
                      <code className="bg-white px-2 py-1 rounded border text-xs font-mono select-text">
                        {code}
                      </code>
                      <span className="text-xs text-gray-500">
                        ({code.length})
                      </span>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Select and copy parts of codes as needed
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      
      <div className="border-gray-400 border-l">
        <span className='ml-4 text-5xl pb-4'>Previous Entries</span>
        {history.slice(-3).map((item, index) => (
          <div 
            key={index} 
            className="flex py-4 border-b border-gray-400 pl-4" 
            onClick={() => handleHistoryClick(index)}
          >
            <img className="h-64" src={item.image} alt={`history-item-${index}`} />
            <div className='ml-4 text-2xl'>
              <div className="font-bold">Box: {item.boxNo}</div>
              {item.weight && <div>Weight: {item.weight}kg</div>}
              {item.trackingNo && <div>Tracking: {item.trackingNo}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WeeklyShipBoxWeightInsert;
